// Shared game data - pool of picture/word/letter items for phonics mini-games
export const GAME_ITEMS = [
  { word: "CAT", emoji: "🐱" },
  { word: "DOG", emoji: "🐶" },
  { word: "SUN", emoji: "☀️" },
  { word: "BAT", emoji: "🦇" },
  { word: "PIG", emoji: "🐷" },
  { word: "HAT", emoji: "🎩" },
  { word: "BUS", emoji: "🚌" },
  { word: "CUP", emoji: "☕" },
  { word: "FOX", emoji: "🦊" },
  { word: "OWL", emoji: "🦉" },
  { word: "BEE", emoji: "🐝" },
  { word: "FISH", emoji: "🐟" },
  { word: "STAR", emoji: "⭐" },
  { word: "MOON", emoji: "🌙" },
  { word: "TREE", emoji: "🌳" },
  { word: "BOOK", emoji: "📖" },
];

export const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function randomFrom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

// CVC / CVCC blending words with per-phoneme breakdowns.
// `phonemes` is the ordered list of sounds a learner blends together.
// Each phoneme uses a readable spelling; TTS voice will pronounce it clearly.
export const BLENDING_WORDS = [
  { word: "CAT", emoji: "🐱", phonemes: ["c", "a", "t"] },
  { word: "DOG", emoji: "🐶", phonemes: ["d", "o", "g"] },
  { word: "SUN", emoji: "☀️", phonemes: ["s", "u", "n"] },
  { word: "PIG", emoji: "🐷", phonemes: ["p", "i", "g"] },
  { word: "HAT", emoji: "🎩", phonemes: ["h", "a", "t"] },
  { word: "MAP", emoji: "🗺️", phonemes: ["m", "a", "p"] },
  { word: "BED", emoji: "🛏️", phonemes: ["b", "e", "d"] },
  { word: "BUG", emoji: "🐛", phonemes: ["b", "u", "g"] },
  { word: "FOX", emoji: "🦊", phonemes: ["f", "o", "ks"] },
  { word: "CUP", emoji: "☕", phonemes: ["c", "u", "p"] },
  { word: "NET", emoji: "🥅", phonemes: ["n", "e", "t"] },
  { word: "MOM", emoji: "👩", phonemes: ["m", "o", "m"] },
  { word: "TOP", emoji: "🎡", phonemes: ["t", "o", "p"] },
  { word: "JAM", emoji: "🍓", phonemes: ["j", "a", "m"] },
  { word: "LOG", emoji: "🪵", phonemes: ["l", "o", "g"] },
  { word: "FROG", emoji: "🐸", phonemes: ["f", "r", "o", "g"] },
  { word: "STOP", emoji: "🛑", phonemes: ["s", "t", "o", "p"] },
  { word: "DUCK", emoji: "🦆", phonemes: ["d", "u", "k"] },
];
